// src/store/slices/medicineInventorySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BaseUrl from '../../../BaseUrl';

const API_BASE_URL = BaseUrl.pharmacyurl
// Async Thu
export const fetchInventory = createAsyncThunk(
  'medicineInventory/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${API_BASE_URL}/MedicineInventories/GetInventory`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchInventoryById = createAsyncThunk(
  'medicineInventory/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${API_BASE_URL}/MedicineInventories/GetInventoryById?id=${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addToInventory = createAsyncThunk(
  'medicineInventory/add',
  async (inventoryData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.post(`${API_BASE_URL}/MedicineInventories/AddToInventory`, inventoryData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const editInventory = createAsyncThunk(
  'medicineInventory/edit',
  async ({ id, inventoryData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.put(`${API_BASE_URL}/MedicineInventories/Edit Inventory`, inventoryData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const medicineInventorySlice = createSlice({
  name: 'medicineInventory',
  initialState: {
    inventories: [],
    currentInventory: null,
    loading: false,
    error: null,
    totalCount: 0
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentInventory: (state) => {
      state.currentInventory = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch All
      .addCase(fetchInventory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventory.fulfilled, (state, action) => {
        state.loading = false;
        state.inventories = action.payload;
        state.totalCount = action.payload.length;
      })
      .addCase(fetchInventory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch By ID
      .addCase(fetchInventoryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentInventory = action.payload;
      })
      .addCase(fetchInventoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add to Inventory
      .addCase(addToInventory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addToInventory.fulfilled, (state, action) => {
        state.loading = false;
        state.inventories.push(action.payload);
      })
      .addCase(addToInventory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Edit Inventory
      .addCase(editInventory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editInventory.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.inventories.findIndex(inv => inv.id === action.payload.id);
        if (index !== -1) {
          state.inventories[index] = action.payload;
        }
      })
      .addCase(editInventory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, clearCurrentInventory } = medicineInventorySlice.actions;
export default medicineInventorySlice.reducer;